import { convertFeeInMainUnitToMinUnit, convertFeeInMinUnitToMainUnit } from '../../../../common/utils/fee.helper';
import { RestaurantDepositSettingsResponse } from '../models/restaurant-deposit-settings-response';
import { UpdateRestaurantDepositSettingsRequest } from '../models/update-restaurant-deposit-settings-request';

export const convertFormValuesToUpdateRequest = (
  form: RestaurantDepositSettingsResponse,
): UpdateRestaurantDepositSettingsRequest => {
  return {
    isDepositEnabled: form.isDepositEnabled,
    bowlsAmount: convertFeeInMainUnitToMinUnit(form.bowlsAmount),
    cupsAmount: convertFeeInMainUnitToMinUnit(form.cupsAmount),
    pizzaAmount: convertFeeInMainUnitToMinUnit(form.pizzaAmount),
    currency: form.currency,
    isExpiryEnabled: form.isExpiryEnabled,
    expiryDays: form.expiryDays,
  };
};
export const convertResponseToFormValues = (
  response: RestaurantDepositSettingsResponse,
): RestaurantDepositSettingsResponse => {
  return {
    ...response,
    bowlsAmount: convertFeeInMinUnitToMainUnit(response.bowlsAmount),
    cupsAmount: convertFeeInMinUnitToMainUnit(response.cupsAmount),
    pizzaAmount: convertFeeInMinUnitToMainUnit(response.pizzaAmount),
    history: response.history.map((historyElement) => {
      return {
        ...historyElement,
        cups: convertFeeInMinUnitToMainUnit(historyElement.cups),
        bowls: convertFeeInMinUnitToMainUnit(historyElement.bowls),
        pizza: convertFeeInMinUnitToMainUnit(historyElement.pizza),
      };
    }),
  };
};
